
<form  name="form" (ngSubmit)="f.form.valid && login()" #f="ngForm" novalidate>
    <div class="card card-login">
        <div class="card-content">
            <div class="row">
                <div class="container-fluid">
                    <div class="login-header text-center">
                        <img src="assets/img/able/NewEra_ABLE_Master_Logo_CMYK.png" class="logo" alt="able+" title="able+" />
                        <h3 class="title hidden">able+</h3>
                    </div>
                </div>
            </div>
            <div *ngIf="!isUserAuthenticated">
                <div class="row">
                    <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11">
                        <span class="input-group-addon">
                            <i class="material-icons">account_box</i>
                        </span>
                        <div class="form-group label-floating is-empty" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
                            <label class="control-label">Username</label>
                            <input type="text" class="form-control" name="username" [(ngModel)]="logInForm.username" #username="ngModel" required />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11">
                        <span class="input-group-addon">
                            <i class="material-icons">lock</i>
                        </span>
                        <div class="form-group label-floating is-empty" [ngClass]="{ 'has-error': f.submitted && !password.valid }">
                            <label class="control-label">Password</label>
                            <input [type]="type" class="form-control" name="password" [(ngModel)]="logInForm.password" #password="ngModel" required />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-lg-11 col-sm-11 col-xs-11">
                        <a *ngIf="passwordMode" class="pull-right cursor-pointer" title="Show password" (click)="passwordModeOff();">
                            <span class="text-gray">
                                <i class="mdi mdi-eye"></i>
                            </span>
                        </a>
                        <a *ngIf="!passwordMode" class="pull-right cursor-pointer" title="Hide password" (click)="passwordModeOn();">
                            <span class="text-gray">
                                <i class="mdi mdi-eye-off"></i>
                            </span>
                        </a>
                    </div>
                </div>
                <div class="text-center margin-top-base padding-top-base">
                    <button [disabled]="loading" class="btn btn-primary btn-block">Login</button>
                </div>
            </div>
            <div class="text-center login-header" *ngIf = "isUserAuthenticated">
                <!-- <h3>Hi {{currentUser.firstName}}!</h3> -->
                <p>You're logged in to able+!</p>
            </div>
        </div>
        <div class="footer text-center">
            <div class="small">
                <a routerLink="/forgot-password" routerLinkActive="active">Forgot password or username?</a>
            </div>
        </div>
    </div>
    <!----card end------>
</form>